const $ = require('jquery');

function animateTop(el: HTMLDivElement, duration: number = 300): void {
    if (el) {
        $(el).animate({ scrollTop: 0 }, duration);
    }
}

export default animateTop;
